import { render, staticRenderFns } from "./VLoader.vue?vue&type=template&id=2e10bb2f"
import script from "./VLoader.js?vue&type=script&lang=js&external"
export * from "./VLoader.js?vue&type=script&lang=js&external"
import style0 from "./VLoader.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
